import { useTranslation } from "react-i18next";

import { IconTicket02 } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

import { ROUTES } from "@constants/routes";

export const CreateTicketHeader = ({
  redirectToListPage,
}: {
  redirectToListPage: () => void;
}) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconTicket02 fill="dark" size="20" />,
    },
    {
      label: t("TICKETS.CREATE.BREADCRUMBS.FIRST_STEP"),
      link: ROUTES.TICKETS.MY_TICKETS,
    },
    {
      label: t("TICKETS.CREATE.BREADCRUMBS.SECOND_STEP"),
    },
  ];

  const headerText = {
    header: t("TICKETS.CREATE.HEADING"),
  };

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      actions={[
        <Button
          fill="outline"
          type="light"
          size="sm"
          onClick={redirectToListPage}
        >
          {t("TICKETS.CREATE.FORM.CANCEL")}
        </Button>,
        <Button fill="fill" type="primary" size="sm" htmlType="submit">
          {t("TICKETS.CREATE.FORM.SUBMIT")}
        </Button>,
      ]}
    />
  );
};
